import { render, staticRenderFns } from "./FibuMitgliedsbeitraegeVerwaltung.vue?vue&type=template&id=1bf513bc&scoped=true&"
import script from "./FibuMitgliedsbeitraegeVerwaltung.vue?vue&type=script&lang=js&"
export * from "./FibuMitgliedsbeitraegeVerwaltung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf513bc",
  null
  
)

export default component.exports